export default class ReductionPO {
    billsId:Array<string>;
    reductionType:number;
    isRatio:number;
    reductionTotal:number;
}